/**
 * @return {string}
 */
function IsBoolean(props) {
  return props.value ? 'Yes' : 'No';
}

export { IsBoolean };
